import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState, useCallback, } from 'react';
export const createPortal = () => {
    const Context = createContext({ element: undefined, addElement: () => { }, removeElement: () => { } });
    const Provider = (props) => {
        const [elements, setElements] = useState([]);
        return (_jsx(Context.Provider, { value: {
                element: elements.at(-1),
                addElement: useCallback(element => setElements(x => [...x.filter(y => y !== element), element]), []),
                removeElement: useCallback(element => setElements(x => x.filter(y => y !== element)), []),
            }, children: props.children }));
    };
    const Portal = (props) => {
        const { addElement, removeElement } = useContext(Context);
        // Need to wrap children in a React component to do referential equality check
        // as children can also be primitive like number, string, etc
        const wrappedElement = useMemo(() => _jsx(_Fragment, { children: props.children }), [props.children]);
        useEffect(() => {
            addElement(wrappedElement);
            return () => removeElement(wrappedElement);
        }, [addElement, removeElement, wrappedElement]);
        return null;
    };
    const Element = () => _jsx(_Fragment, { children: useContext(Context).element });
    return [Provider, Portal, Element];
};
//# sourceMappingURL=portal.js.map